/**
 * Convert JointJS element to Canvas element
 */

import type { CanvasElement } from './types'

export function convertToCanvasElement(
  jointElement: any,
  type: 'parking_space' | 'background' | 'static' = 'static'
): CanvasElement {
  const attrs = jointElement.attributes?.attrs || {}
  const body = attrs.body || {}
  const position = jointElement.attributes?.position || { x: 0, y: 0 }
  const size = jointElement.attributes?.size || { width: 100, height: 100 }

  return {
    id: jointElement.id || `canvas_${Date.now()}`,
    type,
    pathData: body.d || '',
    fill: body.fill || '#4CAF50',
    stroke: body.stroke || '#333333',
    strokeWidth: body.strokeWidth || 2,
    opacity: body.opacity || 0.8,
    position,
    bounds: {
      x: position.x,
      y: position.y,
      width: size.width,
      height: size.height
    },
    layer: jointElement.attributes?.data?.layer || 'default',
    zIndex: jointElement.attributes?.z || 5
  }
}
